import React, { forwardRef } from 'react';
import styled from 'styled-components/macro';
import Icon from './Icon';

import cssToggleIconState from './cssToggleIconState';
import { trackingId, rem, useFocusVisibleIE } from '@blueprint/ui';

/**
 * ButtonIcon
 */
const ButtonIconWrapper = styled(Icon).attrs({
  component: 'button',
  'data-testid': 'Icon',
  'data-trackid': trackingId('ButtonIcon'),
})`
  ${({ disabled, name, hasToggleIconState }) =>
    hasToggleIconState
      ? !disabled && cssToggleIconState(name, ['hover'])
      : null};

  appearance: none;
  display: inline-flex;
  border: none;
  width: ${({ size }) => (size ? rem(size) : rem(18))};
  height: ${({ size }) => (size ? rem(size) : rem(18))};
  padding: 0;
  background-color: transparent;
  cursor: pointer;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.3;
  }
`;

const ButtonIcon = forwardRef(({ hasToggleIconState = true, ...rest }, ref) => {
  const focusVisibleIE = useFocusVisibleIE(rest);

  return (
    <ButtonIconWrapper
      ref={ref}
      type="button"
      hasToggleIconState={hasToggleIconState}
      {...rest}
      {...focusVisibleIE}
    />
  );
});

ButtonIcon.displayName = 'ButtonIcon';

export default React.memo(ButtonIcon);
